import React from 'react';
import PropTypes from 'prop-types';

import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';

function ActionDropDown({ submenuItems, label = 'Actions', className = '' }) {
  const renderDropdownItem = (submenuItem, index) => {
    const dropdownItem = (
      <Dropdown.Item
        onClick={submenuItem.action}
        key={index}
        className={css(styles.dropdownItem)}
        disabled={submenuItem.disabled || false}
      >
        {submenuItem.title}
      </Dropdown.Item>
    );

    // If tooltip is provided, wrap with OverlayTrigger
    if (submenuItem.tooltip) {
      return (
        <OverlayTrigger
          key={index}
          placement="left"
          overlay={<Tooltip>{submenuItem.tooltip}</Tooltip>}
          delay={{ show: 500, hide: 250 }}
        >
          {dropdownItem}
        </OverlayTrigger>
      );
    }

    return dropdownItem;
  };

  return (
    <Dropdown drop="down" className={className}>
      <Dropdown.Toggle variant="outline-primary">{label}</Dropdown.Toggle>
      <Dropdown.Menu className={css(styles.dropdownMenu)}>
        {submenuItems.map((submenuItem, index) => renderDropdownItem(submenuItem, index))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

const styles = StyleSheet.create({
  dropdownMenu: {
    padding: '0rem',
    minWidth: '6.4rem',
    fontSize: '0.8rem',
  },
  dropdownItem: {
    padding: '0.5rem 0.7rem',
    textDecoration: 'none',
  },
});

ActionDropDown.propTypes = {
  submenuItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired,
      disabled: PropTypes.bool,
      tooltip: PropTypes.string,
    }),
  ),
  label: PropTypes.string,
  className: PropTypes.string,
};

export default ActionDropDown;
